import { defaultReducer } from 'app/store/defaultReducer';
import { createReducerTool, createStateTool } from 'app/store/withDevTools';
import moment from 'moment';
import { RecorrenciaTypes } from './recorrenciaAction';

const searchInitialState = {
  dataVencimentoInicio: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
  dataVencimentoFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)),
};

export const RecorrenciaInitState = createStateTool({
  registro: undefined,
  visualizar: false,
  visualizarRecorrencia: false,
  cadastrar: false,
  baixarConta: false,
  page: { content: [] },
  requestParams: {
    page: 0,
    size: 15,
    q: undefined,
    sort: 'dataVencimento,desc',
    totalCount: undefined,
  },
  selection: [],
  message: undefined,
  search: {
    ...searchInitialState,
  },
  selecionados: [],
  carregandoRegistro: false,
  carregandoRegistros: false,
  tipoSelecao: 'NENHUM', // NENHUM, TODOS_PAGINA, TODOS_FILTRO
});

function reducer(state, action, types) {
  if (action.type === RecorrenciaTypes.FECHAR_MODAL) {
    return {
      ...state,
      cadastrar: false,
      visualizar: false,
      baixarConta: false,
      visualizarRecorrencia: false,
    };
  }

  if (action.type === RecorrenciaTypes.VISUALIZAR_RECORRENCIA) {
    return {
      ...state,
      visualizarRecorrencia: action.payload,
    };
  }

  if (action.type === RecorrenciaTypes.PESQUISA_VENCIMENTO) {
    return {
      ...state,
      search: action.payload,
    };
  }

  if (action.type === RecorrenciaTypes.SET_DEFAULT_VALUE) {
    return {
      ...state,
      search: { ...searchInitialState },
    };
  }

  return defaultReducer(state, action, types);
}

export const RecorrenciaReducer = createReducerTool(reducer, RecorrenciaTypes);
